const state = function () {
  return {
    token: null,
    sesionExpirada: false,
    errorConexion: false,
  };
};

const mutations = {
  SET_TOKEN: function (state, token) {
    state.token = token;
  },

  RESET_TOKEN: function (state) {
    state.token = null;
  },

  SET_SESION_EXPIRADA: function (state, valor) {
    state.sesionExpirada = valor;
  },

  SET_ERROR_CONEXION: function (state, valor) {
    state.errorConexion = valor;
  },
};

const getters = {
  getToken: (state) => state.token,
  getSesionExpirada: (state) => state.sesionExpirada,
  getErrorConexion: (state) => state.errorConexion,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {},
};